module.exports = __webpack_public_path__ + "static/media/piccopy.e3574700.svg";